var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Progress chart") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Supreme",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Supreme-(Normal)",
    transform: "translate(-40, -598)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy-2",
    transform: "translate(20, 459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Progress-chart",
    transform: "translate(21, 140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.98398583,0 C4.01513362,0.00868599922 -0.00649634199,4.04261813 0,9.01147365 C0.00651209876,13.9803292 4.03868908,18.0037189 9.00754696,17.9993862 C13.9764048,17.9950466 18.0015535,13.9646255 17.9993863,8.99576622 C17.9972174,4.02690692 13.968553,0 8.99969325,0",
    id: "Background",
    stroke: "#79E78B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.57941842,12.4205817 L4.26174504,10.1029083 C3.91275175,9.75391499 3.91275175,9.1901566 4.26174504,8.84116331 C4.61073833,8.49217002 5.17449672,8.49217002 5.52349001,8.84116331 L7.21476518,10.5234899 L12.4765101,5.26174497 C12.8255034,4.91275168 13.3892618,4.91275168 13.7382551,5.26174497 C14.0872484,5.61073826 14.0872484,6.17449664 13.7382551,6.52348993 L7.84116339,12.4205817 C7.50111864,12.7695749 6.92841171,12.7695749 6.57941842,12.4205817 Z",
    id: "TaskSuccessCheckmark",
    fill: "#79E78B"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.31eb5f53b54991f73c6094f3e41ec353.svg";
export { ForwardRef as ReactComponent };